import React from "react";
import { useSelector } from "react-redux";

import FiltrationTag from "../../../components/FiltrationTag/FiltrationTag";
import useSearchParamsState from "../../../../../hooks/useSearchParamsState";

const FiltrationTags = () => {
	const meterTypes = useSelector((store) => store.meterStore?.meterTypes);
	const tags = useSelector((store) => store.meterStore?.tags);
	const [activeTypes, setActiveTypes] = useSearchParamsState(
		"types",
		[],
		(arr) => arr?.map(Number)
	);
	const [activeTags, setActiveTags] = useSearchParamsState("tags", [], (arr) =>
		arr?.map(Number)
	);

	if (!activeTypes?.length && !tags.length) {
		return null;
	}
	

	return (
		<>
			{activeTypes.map((typeId) => {
				const type = meterTypes?.find((meterType) => meterType.id === typeId);
				return (
					<FiltrationTag
						className="filtration-tag filtration-tag-active-in-address"
						type={type}
						inAddress
						key={typeId}
						onDelete={() =>
							setActiveTypes(
								activeTypes?.filter((typeId) => {
									return typeId !== type?.id;
								})
							)
						}
					/>
				);
			})}
			{activeTags.map((tagId) => {
				const tag = tags?.find((tag) => tag.id === tagId);
				return (
					<FiltrationTag
						className="filtration-tag filtration-tag-active-in-address"
						type={tag}
						inAddress
						key={tagId}
						onDelete={() =>
							setActiveTags(
								activeTags?.filter((tagId) => {
									return tagId !== tag?.id;
								})
							)
						}
					/>
				);
			})}
		</>
	);
};

export default FiltrationTags;
